import { useMemo } from 'react';

import { useInject } from '@vk-hr-tek/core/ioc';
import { FilesService } from '@vk-hr-tek/core/files/files.service';
import { ImageConverter } from '@vk-hr-tek/core/image-converter';
import { ImageRotator } from '@vk-hr-tek/core/image-rotator';
import { Logger } from '@vk-hr-tek/core/logger';
import { LocalStorage } from '@vk-hr-tek/core/local-storage';
import { VKHRTekUIServices } from '@vk-hr-tek/ui/services';
import { FileType } from '@vk-hr-tek/core/file-type';
import { Calendar } from '@vk-hr-tek/core/calendar';
import { ValidationService } from '@vk-hr-tek/core/validation';

export const ModeEnum = {
  VK: 'vk',
  OTP: 'otp',
  GENERAL: 'general',
  GENERAL_DARK: 'general-dark',
  VK_DARK: 'vk-dark',
} as const;

export type ModeType = (typeof ModeEnum)[keyof typeof ModeEnum];

export const useTheme = (): ModeType => {
  const themeLocalStorage =
    useInject<LocalStorage>(LocalStorage).getItem('theme');

  if (themeLocalStorage === 'vk') {
    return 'vk';
  } else if (themeLocalStorage === 'otp') {
    return 'otp';
  } else if (themeLocalStorage === 'general') {
    return 'general';
  } else if (themeLocalStorage === 'general-dark') {
    return 'general-dark';
  } else if (themeLocalStorage === 'vk-dark') {
    return 'vk-dark';
  } else if (window.REACT_APP_VKHRTEK_THEME === 'vk') {
    return themeLocalStorage === 'dark' ? 'vk-dark' : 'vk';
  } else if (window.REACT_APP_VKHRTEK_THEME === 'otp') {
    return 'otp';
  } else {
    return themeLocalStorage === 'dark' ? 'general-dark' : 'general';
  }
};

export const useVKHRTekUIServices = (): Partial<VKHRTekUIServices> => {
  const filesService = useInject(FilesService);
  const imageConverter = useInject(ImageConverter);
  const imageRotator = useInject(ImageRotator);
  const calendar = useInject(Calendar);
  const logger = useInject(Logger);
  const fileType = useInject(FileType);
  const validation = useInject(ValidationService);

  return useMemo(
    () => ({
      filesService,
      imageConverter,
      imageRotator,
      logger,
      fileType,
      validation,
      calendar,
    }),
    [
      filesService,
      imageConverter,
      imageRotator,
      logger,
      fileType,
      validation,
      calendar,
    ],
  );
};
